import { TitleSmallEmphasized } from '@/design-system';
import { css } from '@emotion/css';
import { useURLSearchParams } from '@/hooks';
import { useCallback, useEffect, useState } from 'react';
import { useLazyQuery } from '@apollo/client';
import { GET_SCHOOL, GET_DISTRICT } from '@/graphql/queries';
import { GetSchoolResponse, GetDistrictResponse } from '@/graphql/types';
import { SubscriptionTypeEnum } from '@/config/constants';

export const JarHeaderUnauthenticated: React.FC = () => {
  const { audienceId, audienceType } = useURLSearchParams();
  const [getSchoolById] = useLazyQuery<GetSchoolResponse>(GET_SCHOOL);
  const [getDistrictById] = useLazyQuery<GetDistrictResponse>(GET_DISTRICT);
  const [institutionName, setInstitutionName] = useState<string>('');

  const getSchool = useCallback(async () => {
    if (audienceId && audienceType === SubscriptionTypeEnum.school) {
      try {
        const { data } = await getSchoolById({
          variables: {
            schoolId: Number(audienceId),
          },
        });

        if (data?.getSchool) {
          setInstitutionName(data.getSchool.name);
        }
      } catch (err) {
        console.log('Error fetching school:', err);
      }
    }
  }, [audienceId, audienceType, getSchoolById]);

  const getDistrict = useCallback(async () => {
    if (audienceId && audienceType === SubscriptionTypeEnum.district) {
      try {
        const { data } = await getDistrictById({
          variables: {
            districtId: Number(audienceId),
          },
        });

        if (data?.getDistrict) {
          setInstitutionName(data.getDistrict.name);
        }
      } catch (err) {
        console.log('Error fetching district:', err);
      }
    }
  }, [audienceId, audienceType, getDistrictById]);

  useEffect(() => {
    if (audienceId === 'all') {
      getDistrict();
    } else if (audienceType === SubscriptionTypeEnum.school) {
      getSchool();
    } else if (audienceType === SubscriptionTypeEnum.district) {
      getDistrict();
    }
  }, [audienceId, audienceType, getSchool, getDistrict]);

  return (
    <div className={cn.container}>
      <div className={cn.wrapper}>
        <TitleSmallEmphasized nonTranslate as="h1">
          {institutionName}
        </TitleSmallEmphasized>
      </div>
    </div>
  );
};

const cn = {
  container: css`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    margin-top: 24px;
  `,
  wrapper: css`
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    padding-bottom: 4px;
  `,
};
